import axios from "axios";
import { getUrl } from "./urls";
import { toast } from "react-toastify";
import { getAccessToken } from "./utils";

export const ADD_DATA_WITHOUT_FORCE = "ADD_DATA_WITHOUT_FORCE";
export const ADD_DATA_WITH_FORCE = "ADD_DATA_WITH_FORCE";
export const UNBLOCK = "UNBLOCK";

export const addDataWithForce = (val) => {
    let url = `${getUrl("block-source")}/add?access-token=${getAccessToken()}`;
    let companyId = JSON.parse(localStorage.getItem("company")).company_id;
    let param = {};
    param.url = val;
    param.company_id = companyId;

    let req = axios({
        method: "POST",
        url: url,
        data: param,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            toast.success("URL successfully blocked");

            return res.data.data;
        })
        .catch((error) => {
            if (error.response && error.response.data && error.response.data.message) toast.error(error.response.data.message);
            else toast.error("An error occured while processing your request");

            return error;
        });

    return {
        type: ADD_DATA_WITH_FORCE,
        payload: req,
    };
};

export const addDataWithoutForce = () => {
    let url = `${getUrl("block-source")}/list?access-token=${getAccessToken()}`;
    let req = axios({
        method: "get",
        url: url,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            return res.data.data;
        })
        .catch((err) => {
            console.log(err);
            return err;
        });

    return {
        type: ADD_DATA_WITHOUT_FORCE,
        payload: req,
    };
};

export const unblockAddedSources = (val) => {
    let url = `${getUrl("block-source")}/${val}?access-token=${getAccessToken()}`;
    let req = axios({
        method: "delete",
        url: url,
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => {
            toast.success("URL Unblocked");
            return res.data.data;
        })
        .catch((err) => {
            console.log(err);
            return err;
        });

    return {
        type: UNBLOCK,
        payload: req,
    };
};
